<template>
    <v-container class="main-container">
        <message-component id="message" v-model="isMessage" :success="this.message.success" style="white-space:pre-wrap; word-wrap:break-word;">{{ message.text }}</message-component>
        <v-container style="margin-top: 15px;">
            <v-row>
                <v-col cols="12" xl="6" class="text-h4">契約先メンバー一覧</v-col>
                <template v-if="user.role == true"> <!-- 管理者 -->
                    <v-col cols="12" xl="12" class="text-right">
                        <v-btn color="red" class="white--text" @click="clickAdd(companies)">契約先メンバーを追加する</v-btn>
                        <br>
                        <v-btn color="orange" class="white--text" @click="downloadCSV">CSVエクスポート</v-btn>
                        <input id="fileUpload" name="csv" class="file_input" type="file" ref="file" @change="uploadCSV" accept="text/csv" hidden>
                        <v-btn @click="chooseFiles" color="orange" class="white--text">CSVインポート</v-btn>

                    </v-col>
                </template>
            </v-row>
        </v-container>

        <!-- 検索エリア -->
        <v-expansion-panels>
            <v-expansion-panel>
                <v-expansion-panel-header color="#F4FEFB">
                </v-expansion-panel-header>
                <v-expansion-panel-content color="#F4FEFB">
                    <form @submit.prevent="search">
                        <v-container>
                            <v-row>
                                <v-col cols="12" xl="2">
                                    <badge-component tile color="unset">
                                        <label-component>メールアドレス</label-component>
                                    </badge-component>
                                </v-col>
                                <v-col cols="12" xl="2">
                                    <v-text-field v-model="searchItem.email" outlined clearable v-disabled-icon-focus background-color="white"></v-text-field>
                                </v-col>
                                <v-col cols="12" xl="2">
                                    <badge-component tile color="unset">
                                        <label-component>契約先企業</label-component>
                                    </badge-component>
                                </v-col>
                                <v-col cols="12" xl="2">
                                    <v-select
                                        v-model="searchItem.company_id"
                                        :items="companies"
                                        outlined
                                        clearable
                                        v-disabled-icon-focus
                                        background-color="white"
                                    ></v-select>
                                </v-col>
                                <v-col cols="12" xl="1">
                                    <label-component>
                                        <v-btn
                                            color="blue"
                                            class="white--text"
                                            type="submit"
                                        >
                                            検索
                                        </v-btn>
                                    </label-component>
                                </v-col>
                            </v-row>
                        </v-container>
                    </form>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>

        <div>
            <!-- テーブル -->
            <template>
                <v-pagination
                    v-model="indexInfo.page"
                    :length="indexInfo.pageCount"
                ></v-pagination>
                <v-data-table
                    :headers="headers"
                    :items="items"
                    :page.sync="indexInfo.page"
                    :items-per-page="indexInfo.itemsPerPage"
                    @page-count="indexInfo.pageCount = $event"
                    disable-sort
                    hide-default-footer
                >
                    <template v-slot:body="props">
                        <tr v-for="(item, index) in props.items" :key="index">
                            <td class="item-td" align="center">{{ item.email }}</td>
                            <td class="item-td" align="center">{{ item.company_name }}</td>
                            <td class="item-td" align="center">{{ item.name }}</td>
                            <td align="center">
                                <template v-if="user.role == true"> <!-- 管理者 -->
                                    <v-btn color="blue" class="white--text" @click="clickDetail(item, companies)">詳細</v-btn>
                                </template>
                            </td>
                            <td align="center">
                                <template v-if="user.role == true"> <!-- 管理者 -->
                                    <v-btn color="blue-grey" class="white--text" @click="clickDelete(item)">削除</v-btn>
                                </template>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </template>
        </div>

        <!-- 契約先メンバー追加 -->
        <contract-destination-members-add-dialog-component v-if="addDialog" :addDialog.sync="addDialog" :item="currentCompanies" @success="reSearch" @error="error">
            <template v-slot:message>詳細</template>
            <template v-slot:ok-btn>保存</template>
            <template v-slot:cancel-btn>キャンセル</template>
        </contract-destination-members-add-dialog-component>

        <!-- 詳細 -->
        <contract-destination-members-dialog-component v-if="detailDialog" :detailDialog.sync="detailDialog"
            :item="{id: currentItem.id, name: currentItem.name, email: currentItem.email, contractor_company_id: currentItem.contractor_company_id, companies: currentCompanies}"
            @success="reSearch" @error="error"
        >
            <template v-slot:message>詳細</template>
            <template v-slot:ok-btn>保存</template>
            <template v-slot:cancel-btn>キャンセル</template>
        </contract-destination-members-dialog-component>
        
        <!-- 削除 -->
        <delete-dialog-component v-if="deleteDialog" :deleteDialog.sync="deleteDialog" :item="{id: currentItem.id, table: '/documents/delete-contract-destination-members/'}" @success="reSearch" @error="error">
            <template v-slot:title>{{ currentItem.name }}を削除しますか？</template>
            <template v-slot:ok-btn>削除</template>
            <template v-slot:cancel-btn>キャンセル</template>
        </delete-dialog-component>
    </v-container>
</template>

<script>
    import moment from "moment";
    export default {
        props: ['user'],
        data() {
            return {
                // 項目一覧
                items: [],
                // 契約先企業
                companies: [],
                // 検索項目
                searchItem: {
                    email: '',
                    company_id: '',
                },
                indexInfo: {
                    // ページ数
                    page: 1,
                    // 最大ページ数
                    pageCount: 0,
                    // 1ページあたりの項目数
                    itemsPerPage: 10,
                },
                // ソート、ページネーション
                options: {},
                // テーブルヘッダー
                headers: [
                  { text: 'メールアドレス', align: 'center', value: 'email' },
                  { text: '契約先企業', align: 'center', value: 'company_name' },
                  { text: '氏名', align: 'center', value: 'name' },
                  { text: '', value: 'action', sortable: false },
                  { text: '', value: 'action', sortable: false },
                ],
                // 契約先メンバー追加 開閉フラグ
                addDialog: false,
                // 詳細 開閉フラグ
                detailDialog: false,
                // 削除 開閉フラグ
                deleteDialog: false,
                // メッセージ
                message: {
                    success: false,
                    text: '',
                },
                // success: false,
           };
        },
        methods: {
             // 契約先メンバー追加ボタン押下
            clickAdd(companies) {
                this.addDialog = true;
                this.currentCompanies = companies;
            },
            // 詳細ボタン押下
            clickDetail(item, companies) {
                this.detailDialog = true;
                this.currentItem = item;
                this.currentCompanies = companies;
            },
            // 削除ボタン押下
            clickDelete(item) {
                this.deleteDialog = true;
                this.currentItem = item;
            },
            chooseFiles: function() {
                document.getElementById("fileUpload").click();
            },
            // 検索
            search() {
                var self = this;
                window.axios.post('/documents/search-contract-destination-members', this.searchItem).then((res) => {
                    self.items = res.data.items;
                    self.companies = res.data.companies;
                });
            },
            // 再検索
            reSearch(message) {
                var self = this;
                window.axios.post('/documents/search-contract-destination-members', this.searchItem).then((res) => {
                    self.items = res.data.items;
                    self.companies = res.data.companies;
                    self.message.success = true;
                    self.message.text = message;
                });
            },
            downloadCSV () {
                var csv = '\ufeff' + '担当者氏名,メールアドレス,契約先企業ID,企業名\n';
                var fileName = '契約先メンバー一覧' + moment().format( "YYYY年MM月DD日" ) + '時点';
                this.items.forEach(el => {
                    var line = el['name'] + ',' + el['email'] + ',' + el['contractor_company_id'] + ',' + el['company_name'] + '\n';
                    csv += line;
                });
                let blob = new Blob([csv], { type: 'text/csv' });
                let link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = fileName + '.csv';
                link.click();
                
                window.axios.post('/documents/operation-log/save', {
                    display_name: '契約先メンバー一覧',
                    operation: '契約先メンバーエクスポート',
                    table_name: '契約先メンバー',
                });
            },
            uploadCSV(e){
                const formData = new FormData();
                let config = {
                    headers: {
                        'content-type': 'multipart/form-data'
                    }
                };
                const files = e.target.files || e.dataTransfer.files;
                formData.append('file',files[0]);
                // ファイルサイズ
                if (files[0].size > (20 * 1024 * 1024)) {
                    this.message.text = "1ファイルのサイズは最大20MBまでです";
                    this.message.success = false;
                    this.$refs.file.value = null;
                    return false;
                }
                // // 企業名
                // if (!this.name) {
                //     this.errors.push("Name required.");
                // }
                var self = this;
                window.axios
                    .post('/documents/contract-destination-members-import-csv', formData, config)
                    .then(function (response) {
                        if(response.data.success){
                            self.items = response.data.items;
                            self.companies = response.data.companies;
                            self.message.success = true;
                            self.message.text = "インポート処理が完了しました";
                        } else {
                            self.message.success = false;
                            if (response.data.message) {
                                self.message.text = response.data.message;
                            } else {
                                self.message.text = "インポート処理に失敗しました";
                            }
                        }
                    })
                    .catch(function (response) {
                        console.log(response);
                        self.message.text = "インポート処理に失敗しました";
                        self.message.success = false;
                    })
                    .finally(function () {
                        self.$refs.file.value = null;
                    })
                ;
            },
            
            // エラー
            error(message) {
                this.message.success = false;
                this.message.text = message;
            }
        },
        // 初期表示のデータ
        mounted() {
            window.axios.get('/documents/get-contract-destination-members').then((res) => {
                this.items = res.data.items;
                this.companies = res.data.companies;
            });
        },
        computed: {
            // メッセージ
            isMessage: {
                get() {
                    return this.message.text != '';
                },
                set(value) {
                    if (!value) {
                        this.message.text = '';
                    }
                }
            },
        },
    };
</script>

<style scoped>
    .file_input {
        display: none;
    }
    
    .notice-icon {
        margin-right: 10px !important;
    }

    .main-container {
        font-family: $body-font-family;
        font-size: $font-size-root;
    }

    .main-content-area {
        margin-top: 10px;
    }

    .common-dialog-message {
        font-size: 16px !important;
        color: black !important;
    }

    /* table */
    .v-btn:not(.v-btn--round).v-size--default {
        margin: 2px 0;
    }
    td {
        border-bottom: solid 1px rgb(0, 0, 0, 0.05);
    }

    /* 検索エリア */
    .v-expansion-panels {
        margin: 10px 0;
    }
    .v-expansion-panel-content__wrap {
        padding-bottom: 0;
    }
</style>